import { Box, Stack, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { SystemEvent } from '@weft/types';
import { dayjs } from '@weft/utils';
import React from 'react';
import { getSystemEventLabel } from '../../../../utils/get-system-event-label';

type LightInvoiceViewPageActivityProps = {
  systemEvents: SystemEvent[];
};

export const LightInvoiceViewPageActivity: React.FC<LightInvoiceViewPageActivityProps> = ({ systemEvents }) => {
  return (
    <Stack
      padding={3}
      spacing={2}
    >
      <Typography variant="body1">Activity</Typography>

      <Stack direction="column">
        {systemEvents.map((systemEvent, index) => (
          <React.Fragment key={systemEvent.id}>
            {index > 0 && (
              <Box
                sx={{
                  backgroundColor: '#0D1B271A',
                  height: '50px',
                  width: '1px',
                  marginLeft: '23px',
                }}
              />
            )}

            <Stack
              key={systemEvent.id}
              direction="row"
              columnGap="10px"
              alignItems="center"
            >
              <Box style={{
                backgroundColor: '#ECEDEE',
                borderRadius: '50%',
                width: 'min-content',
                padding: '12px',
              }}
              >
                <VyIcon
                  icon="Edit"
                  color="#0D1B274D"
                />
              </Box>
              <Stack direction="column">
                <Typography variant="body2">{getSystemEventLabel(systemEvent)}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  {dayjs(systemEvent.createdAt).format('DD.MM.YY')}
                </Typography>
              </Stack>
            </Stack>
          </React.Fragment>
        ))}
      </Stack>
    </Stack>
  );
};